import { createComponent } from '@carvana/merch-components';

export const ImageryCard = createComponent('div', {
  className:
    'flex h-full w-[300px] cursor-pointer flex-col overflow-hidden rounded-md border border-border-subtle bg-background-default md:w-[268px] md:hover:border-border-default lg:w-[226px] xl:w-[240px]'
});

export const ImageryCardContent = createComponent('div', {
  className: 'flex flex-1 flex-col gap-lg p-2xl'
});

export const ImageryWrapper = createComponent('div', {
  className:
    'relative w-full shrink-0 overflow-hidden aspect-video bg-background-muted-hint'
});

export const MagnifierButton = createComponent('button', {
  className:
    'absolute bottom-md right-md flex items-center justify-center gap-md rounded-round bg-background-default p-md text-text-strong'
});

export const StyledImage = createComponent('img', {
  className: 'w-full h-full rounded-t-md object-cover'
});

export const StyledVideo = createComponent('video', {
  className: 'w-full h-full rounded-t-md object-cover'
});
